import authService from '@shared/global/auth/auth.service';
import { ErrorFallback } from '@pages/error-fallback';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Suspense } from '@core/suspense';
import { Routes } from '@shared/enums';

export const Callback = () => {
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);

  // A ref to ensure the sign-in process is only triggered once.
  // This is critical for compatibility with React's StrictMode in development.
  const hasRun = useRef(false);

  useEffect(() => {
    // We only want this logic to run on the very first render.
    if (hasRun.current) {
      return;
    }
    hasRun.current = true;

    const processCallback = async () => {
      try {
        await authService.signinRedirectCallback();
        navigate(Routes.ROOT, { replace: true });
      } catch (error) {
        // it's not a critical failure. The user is likely already authenticated.
        // Redirect them to the main app just as you would on success.
        if (error instanceof Error && error.message.includes('No matching state')) {
          console.warn('OIDC Callback: Stale page or StrictMode double-invoke. Redirecting home.');
          navigate(Routes.ROOT, { replace: true });
        } else {
          console.error('Error processing signin callback:', error);
          setHasError(true);
        }
      }
    };

    processCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (hasError) {
    return <ErrorFallback type="oidc" />;
  }

  return <Suspense />;
};
